const RU = {
  'sites.subtitle': 'Объекты сети: адреса, часовые пояса, часы работы и статус',

  'sites.col.code': 'Код',
  'sites.col.name': 'Название',
  'sites.col.address': 'Адрес',
  'sites.col.timezone': 'Часовой пояс',
  'sites.col.status': 'Статус',

  'sites.status.active': 'Работает',
  'sites.status.suspended': 'Приостановлен',
  'sites.status.closed': 'Закрыт',

  'sites.empty': 'Объектов нет',
  'sites.emptyReason': 'В сети не заведено ни одного объекта. Заведите первый кнопкой «Добавить».',

  'sites.add': 'Добавить объект',
  'sites.form.new': 'Новый объект',
  'sites.form.code': 'Код',
  'sites.form.codeHint':
    'Короткий код для отчётов и бейджей: латиница, цифры, дефис. Приводится к верхнему регистру и потом не меняется.',
  'sites.form.name': 'Название',
  'sites.form.address': 'Адрес',
  'sites.form.timezone': 'Часовой пояс',
  'sites.form.timezoneHint': 'По нему считаются смены и отчёты объекта.',
  'sites.form.hours': 'Часы работы',
  'sites.form.hoursHint':
    'Закрытие раньше открытия означает работу через полночь. Пустые поля — день не задан.',
  'sites.form.dayOff': 'Выходной',
  'sites.form.formats': 'Форматы услуг',
  'sites.form.formatsHint':
    'Что объект продаёт: от формата зависят каталог и сравнение объектов в отчётах.',
  'sites.form.open': 'с',
  'sites.form.close': 'до',
  'sites.form.status': 'Статус',
  'sites.form.create': 'Завести объект',
  'sites.form.save': 'Сохранить',
  'sites.form.cancel': 'Отмена',

  'sites.created': 'Объект заведён',
  'sites.saved': 'Изменения сохранены',

  'sites.day.mon': 'Пн',
  'sites.day.tue': 'Вт',
  'sites.day.wed': 'Ср',
  'sites.day.thu': 'Чт',
  'sites.day.fri': 'Пт',
  'sites.day.sat': 'Сб',
  'sites.day.sun': 'Вс',

  'sites.forbidden': 'Раздел доступен администратору сети',
  'sites.forbiddenReason':
    'Объекты — настройка всей сети, поэтому заводить и править их может только администратор сети.',
};

const KK: Record<keyof typeof RU, string> = {
  'sites.subtitle': 'Желі нысандары: мекенжайлар, уақыт белдеулері, жұмыс уақыты және мәртебе',

  'sites.col.code': 'Коды',
  'sites.col.name': 'Атауы',
  'sites.col.address': 'Мекенжайы',
  'sites.col.timezone': 'Уақыт белдеуі',
  'sites.col.status': 'Мәртебесі',

  'sites.status.active': 'Жұмыс істейді',
  'sites.status.suspended': 'Тоқтатылған',
  'sites.status.closed': 'Жабылған',

  'sites.empty': 'Нысандар жоқ',
  'sites.emptyReason': 'Желіде бірде-бір нысан жоқ. «Қосу» батырмасымен алғашқысын қосыңыз.',

  'sites.add': 'Нысан қосу',
  'sites.form.new': 'Жаңа нысан',
  'sites.form.code': 'Коды',
  'sites.form.codeHint':
    'Есептер мен бейджтерге арналған қысқа код: латын әрпі, сандар, дефис. Бас әріпке келтіріледі және кейін өзгермейді.',
  'sites.form.name': 'Атауы',
  'sites.form.address': 'Мекенжайы',
  'sites.form.timezone': 'Уақыт белдеуі',
  'sites.form.timezoneHint': 'Ауысымдар мен нысан есептері осы бойынша есептеледі.',
  'sites.form.hours': 'Жұмыс уақыты',
  'sites.form.hoursHint':
    'Жабылу ашылудан ерте болса — түн ортасы арқылы жұмыс. Бос өрістер — күн белгіленбеген.',
  'sites.form.dayOff': 'Демалыс',
  'sites.form.formats': 'Қызмет форматтары',
  'sites.form.formatsHint':
    'Нысан не сатады: каталог пен есептердегі салыстыру форматқа байланысты.',
  'sites.form.open': 'бастап',
  'sites.form.close': 'дейін',
  'sites.form.status': 'Мәртебесі',
  'sites.form.create': 'Нысан қосу',
  'sites.form.save': 'Сақтау',
  'sites.form.cancel': 'Болдырмау',

  'sites.created': 'Нысан қосылды',
  'sites.saved': 'Өзгерістер сақталды',

  'sites.day.mon': 'Дс',
  'sites.day.tue': 'Сс',
  'sites.day.wed': 'Ср',
  'sites.day.thu': 'Бс',
  'sites.day.fri': 'Жм',
  'sites.day.sat': 'Сб',
  'sites.day.sun': 'Жс',

  'sites.forbidden': 'Бөлім желі әкімшісіне қолжетімді',
  'sites.forbiddenReason':
    'Нысандар — бүкіл желінің баптауы, сондықтан оларды тек желі әкімшісі қоса және өзгерте алады.',
};

export type SitesKey = keyof typeof RU;
export type SitesLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<SitesLocale, Record<SitesKey, string>>> = { ru: RU, kk: KK };

export type SitesTranslate = (key: SitesKey, params?: Record<string, string | number>) => string;

export function makeSitesT(locale: SitesLocale): SitesTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
